import {
  GETOPERATIONLOGSLIST_SUCCESS,
  GETOPERATIONLOGSLIST_FAILED,
  RESET_GETOPERATIONLOGSLIST,
  LOADING_GETOPERATIONLOGSLIST,
  NETWORK_ERROR_GETOPERATIONLOGSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetOperationLogsList = () => {
  return { type: RESET_GETOPERATIONLOGSLIST };
};

const getOperationLogsListDetails =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETOPERATIONLOGSLIST });
    await partnerServices
      .post("getOperationLogsList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getOperationLogsListSuccess(res.data));
            break;
          default:
            dispatch(getOperationLogsListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({ type: NETWORK_ERROR_GETOPERATIONLOGSLIST, payload: err });
      });
  };
function getOperationLogsListSuccess(data) {
  return {
    type: GETOPERATIONLOGSLIST_SUCCESS,
    payload: data,
  };
}
function getOperationLogsListFailed(data) {
  return {
    type: GETOPERATIONLOGSLIST_FAILED,
    payload: data,
  };
}

export { resetGetOperationLogsList, getOperationLogsListDetails };
